import { render, staticRenderFns } from "./TasksFiltering.vue?vue&type=template&id=0db4ae92&"
import script from "./TasksFiltering.vue?vue&type=script&lang=js&"
export * from "./TasksFiltering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports